import { render, staticRenderFns } from "./PictureV1.vue?vue&type=template&id=53cf0db4&scoped=true&"
import script from "./PictureV1.vue?vue&type=script&lang=js&"
export * from "./PictureV1.vue?vue&type=script&lang=js&"
import style0 from "./PictureV1.vue?vue&type=style&index=0&id=53cf0db4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf0db4",
  null
  
)

export default component.exports